const  th =  {
 translation: {
  "account": "บัญชี",
  "auth_confirm_read": "ฉันได้อ่านและเข้าใจ",
  "auth_terms_conditions": "ข้อตกลงและเงื่อนไข",
  "auto_input_password": "ใส่รหัสผ่าน",
  "auto_input_username": "ป้อนชื่อผู้ใช้",
  "auto_password": "รหัสผ่าน",
  "auto_username": "ชื่อผู้ใช้",
  "back_home": "กลับไปที่หน้าหลัก",
  "cancel_password": "ยกเลิก",
  "change_password": "เปลี่ยนรหัสผ่าน",
  "confirm_new_password": "ยืนยันรหัสผ่านใหม่",
  "coppy_link_error": "คัดลอกความล้มเหลวของลิงค์",
  "coppy_link_success": "คัดลอกลิงค์สำเร็จ",
  "current_password": "รหัสผ่านปัจจุบัน",
  "download_file_error": "ดาวน์โหลดความล้มเหลว",
  "edit_profile_label_cancle": "ยกเลิก",
  "edit_profile_label_confirm": "ยืนยัน",
  "edit_profile_success": "ข้อมูลที่ประสบความสำเร็จ",
  "edit_profile_text_warning_description": "แน่ใจหรือว่าต้องการยกเลิกการเปลี่ยนแปลง?",
  "email": "Email",
  "error_500": "ระบบโอเวอร์โหลด โปรดลองอีกครั้งในภายหลัง",
  "error_backhome": "กลับไปที่หน้าหลัก",
  "error_confirm_new_password": "ไม่เหมือนรหัสผ่านใหม่",
  "error_new_password": "รหัสผ่านใหม่ไม่สามารถเป็นเหมือนรหัสผ่านปัจจุบันได้",
  "error_page_note_found": "ไม่พบหน้านี้",
  "error_password": "รหัสผ่านปัจจุบันไม่ถูกต้อง",
  "fan_test_key": "th test",
  "footer_title": "©ลิขสิทธิ์เป็นของ",
  "forgot_password": "ลืมรหัสผ่าน",
  "forgot_password_change_password_success": "เปลี่ยนรหัสผ่านให้สำเร็จ",
  "forgot_password_email_verified_account": "อีเมลยังไม่ได้ลงทะเบียนบัญชี",
  "forgot_password_input_placeholder": "ป้อนรหัสผ่านใหม่ของคุณ",
  "forgot_password_reset_password": "รีเซ็ตรหัสผ่าน",
  "forgot_password_success_title": "ใช่ เปลี่ยนรหัสผ่านให้สำเร็จ",
  "forgot_password_title": "คุณป้อนอีเมลการลงทะเบียนที่ถูกต้องเพื่อรับรหัสผ่านกลับ😥",
  "handle_redirect": "Redirect",
  "input_confirm_new_password": "ป้อนรหัสผ่านใหม่",
  "input_current_password": "ป้อนรหัสผ่านปัจจุบัน",
  "input_new_password": "ป้อนรหัสผ่านใหม่ของคุณ",
  "login": "เข้าสู่ระบบ",
  "login_error_email_exist": "อีเมลยังไม่ได้ลงทะเบียนบัญชี",
  "login_error_email_format": "อีเมลไม่ได้อยู่ในรูปแบบ",
  "login_error_email_required": "กรุณากรอกอีเมลของคุณ",
  "login_error_limit_fail": "คุณป้อนรหัสผ่านผิดมากกว่าหมายเลขที่กำหนด กรุณาลองใหม่อีกครั้งในภายหลัง",
  "login_error_password": "รหัสผ่านผิด",
  "login_error_phone_exist": "หมายเลขโทรศัพท์ไม่ได้ลงทะเบียน",
  "login_error_phone_format": "หมายเลขโทรศัพท์ไม่อยู่ในรูปแบบที่ถูกต้อง",
  "login_forget_password": "คุณลืมรหัสผ่านหรือไม่?",
  "login_now": "ลงชื่อเข้าใช้ตอนนี้",
  "login_page_close": "ปิด",
  "login_page_content": "แพลตฟอร์ม passio สำหรับแฟน ๆ",
  "login_page_copy_right": "© Passio -",
  "login_page_password_placeholder": "ป้อนของของคุณ",
  "login_page_placeholder": "กรอกอีเมล์ของคุณ",
  "login_page_question": "ไม่มีบัญชี?",
  "login_page_register": "สมัครตอนนี้",
  "login_page_title": "เข้าสู่ระบบ",
  "login_password_placeholder": "ใส่รหัสผ่าน",
  "login_phone_placeholder": "ป้อนหมายเลขโทรศัพท์ของคุณ",
  "login_reinstall_password": "ติดตั้งรหัสผ่านใหม่",
  "login_success": "เข้าสู่ระบบได้สำเร็จ",
  "login_success_title": "ใช่ เข้าสู่ระบบได้สำเร็จ",
  "new_password": "รหัสผ่านใหม่",
  "next": "ต่อไป",
  "otp_accuracy": "ส่ง",
  "otp_continute_without_verification": "ดำเนินการต่อโดยไม่ต้องรับรองความถูกต้อง",
  "otp_email_title": "รหัสการรับรองความถูกต้องถูกส่งไปยังอีเมล",
  "otp_error_invalid_email": "อีเมลไม่ได้อยู่ในรูปแบบ",
  "otp_error_limit_send_otp": "จำนวนเวลาเริ่มต้นเกินขีด จำกัด ที่อนุญาตโปรดส่ง OTP ใหม่กลับมา",
  "otp_error_limit_time": "คุณได้จัดการมากกว่าจำนวนครั้งที่อนุญาต โปรดส่งคืนหลังจาก {{time}} เพื่อดำเนินการต่อ",
  "otp_error_otp_not_found": "ไม่มีรหัส OTP",
  "otp_error_timeout": "OTP หมดอายุโปรดส่ง OTP กลับมา",
  "otp_resend": "ส่ง OTP กลับมา",
  "otp_screen_please_wait_after": "วินาทีในการส่งกลับ",
  "otp_screen_please_wait_before": "โปรดรอ",
  "password": "รหัสผ่าน",
  "password_accept_condition": "หลังจากกดปุ่มลงทะเบียนแล้วคุณก็ยอมรับ",
  "password_cancle": "ยกเลิก",
  "password_change": "เปลี่ยนรหัสผ่าน",
  "password_confirm": "ยืนยัน",
  "password_error_digit": "ขั้นต่ำ 1 หลัก",
  "password_error_min_length": "ความยาวมากกว่า 8 อักขระ",
  "password_error_timeout": "เมื่อเวลาผ่านไปการตั้งค่ารหัสผ่านโปรดเปิดใหม่",
  "password_error_uppercase": "ตัวพิมพ์ใหญ่ขั้นต่ำ 1 ตัวอักษร",
  "password_input_placeholder": "E.g: Matkhau112360",
  "password_max": "โปรดป้อนอักขระสูงสุด {{max}} อักขระ",
  "password_min": "โปรดป้อนอักขระอย่างน้อย {{min}}",
  "password_required": "โปรดป้อนข้อมูลนี้",
  "password_setup": "การตั้งค่ารหัสผ่าน",
  "password_term_condition": "ข้อตกลงและเงื่อนไข",
  "phone": "หมายเลขโทรศัพท์",
  "register": "ลงทะเบียน",
  "register_email_placeholder": "ใส่อีเมลล์ของคุณ",
  "register_erro_min_length": "ความยาวขั้นต่ำ {{min}} อักขระ",
  "register_error_email_error": "อีเมลไม่ได้อยู่ในรูปแบบ",
  "register_error_email_existed": "อีเมลได้ลงทะเบียนบัญชี",
  "register_error_email_invalid_format": "อีเมลไม่ได้อยู่ในรูปแบบ",
  "register_error_limit_send": "คุณได้จัดการมากกว่าจำนวนครั้งที่อนุญาต โปรดส่งคืนหลังจาก {{time}} เพื่อดำเนินการต่อ",
  "register_error_max_length": "เพิ่มระดับสูงสุด {{max}} อักขระ",
  "register_error_username_existed": "มีชื่อผู้ใช้",
  "register_error_username_matches": "อักขระที่อนุญาตจาก a-z และ 0-9 เท่านั้น",
  "register_otp": "การรับรองความถูกต้องของ OTP",
  "register_page_description": "สร้างบัญชีของคุณและเริ่มต้นการเดินทางที่ Passio",
  "register_page_title": "ลงทะเบียนบัญชี",
  "register_phone_placeholder": "ป้อนหมายเลขโทรศัพท์ของคุณ",
  "register_success": "ลงทะเบียนความสำเร็จ",
  "register_success_description": "ขอแสดงความยินดีกับการลงทะเบียนบัญชีที่ประสบความสำเร็จของคุณ ยินดีต้อนรับสู่แพลตฟอร์ม Passio",
  "register_success_title": "ใช่ ลงทะเบียนความสำเร็จ",
  "register_verified_email": "อีเมลได้ลงทะเบียนบัญชี",
  "save_password": "บันทึก",
  "save_password_false": "รหัสผ่านไม่ได้มีการเปลี่ยนแปลง",
  "save_password_success": "คุณเปลี่ยนรหัสผ่านสำเร็จแล้ว",
  "shoutout_back": "กลับมา",
  "shoutout_content": "เนื้อหา",
  "shoutout_create_request": "สร้างข้อกำหนด",
  "shoutout_created_at": "Created at",
  "shoutout_decline": "ปฏิเสธ",
  "shoutout_expired_time": "Expired time",
  "shoutout_feed_back": "ข้อเสนอแนะจาก {{name}}",
  "shoutout_new": "ใหม่",
  "shoutout_occasion_advice": "คำแนะนำ",
  "shoutout_occasion_birthday": "วันเกิด",
  "shoutout_occasion_mobilize": "ระดมพล",
  "shoutout_occasion_other": "โอกาสอื่น ๆ",
  "shoutout_occasion_question": "คำถาม",
  "shoutout_occasion_special": "โอกาสพิเศษ",
  "shoutout_pronoun_aunt": "นางสาว",
  "shoutout_pronoun_big_uncle": "ลุง",
  "shoutout_pronoun_bro": "คุณ",
  "shoutout_pronoun_friend": "เพื่อน",
  "shoutout_pronoun_grandfather": "ปู่",
  "shoutout_pronoun_grandmother": "ยาย",
  "shoutout_pronoun_he": "พี่ชาย",
  "shoutout_pronoun_she": "พี่สาว",
  "shoutout_pronoun_uncle": "ลุง",
  "shoutout_reject_reason": "เหตุผลในการปฏิเสธ",
  "shoutout_replied": "ทำ",
  "shoutout_request_code": "Request code",
  "shoutout_request_detail": "รายละเอียดที่ต้องการ",
  "shoutout_request_noti": "มีการร้องขอ",
  "shoutout_request_status": "ความต้องการ",
  "shoutout_share": "แบ่งปัน",
  "shoutout_to": "มาถึง",
  "spl_add_item_to_live": "เพิ่มสินค้าในไลฟ์",
  "spl_add_link": "ค้นหาผลิตภัณฑ์",
  "spl_add_link_content_success": "ต้องคลิกปุ่มเข้าลิงก์ด้านล่างเพื่อเข้าถูก livestream ที่มีสินค้าของคุณ",
  "spl_add_link_error_content": "ขณะนี้ไม่สามารถเพิ่มสินค้าในไลฟ์ได้",
  "spl_add_link_error_title": "เกิดข้อผิดพลาดในการเพิ่มสินค้าลงตะกร้า",
  "spl_add_link_title": "เพิ่มลิงก์",
  "spl_add_link_title_success": "เพิ่มสินค้าเข้า Live สำดเร็จแล้ว",
  "spl_back": "ย้อนกลับ",
  "spl_cannot_add_item_to_shopee_live_session": "ไม่สามารถเพิ่มสินค้าใน Shopee live",
  "spl_cannot_find_seller": "ไม่พบข้อมูลผู้ไลฟ์",
  "spl_close": "ปิด",
  "spl_cps_token_is_empty": "ข้อมูลไม่ถูกต้อง",
  "spl_go_to_live_label": "Go now",
  "spl_guide_text": "คำแนะนำในการใช้เครื่องมือ",
  "spl_invalid_url": "URL ไม่ถูกต้อง",
  "spl_item_index": "เลขที่ใบสั่งซื้อในตะกร้าไลฟ์คือ",
  "spl_item_link_click_here": "คลิกที่ลิงก์นี้",
  "spl_link_accept": "Invalid link",
  "spl_link_is_not_empty": "ลิงก์ไม่สามารถเว้นว่างได้",
  "spl_ok": "ตกลง",
  "spl_paste_link_here": "วางลิงค์ที่นี่",
  "spl_position_in_live_label": "Position in LIVE",
  "spl_product_already_exists_in_live": "สินค้าอยู่ในตะกร้าไลฟ์แล้ว",
  "spl_product_empty_searching_label": "No products found",
  "spl_product_invalid": "Please enter the correct Shopee product link",
  "spl_related_product_list_header_label": "Shopee deal hunting",
  "spl_related_product_list_title": "Related products are available in live",
  "spl_shopee_session_id_is_empty": "ไม่พร้อมที่จะไลฟ์",
  "spl_title": "ช้อปปี้ไลฟ์",
  "spl_view_related_product_list_label": "View related products",
  "ss_add_voucher_successs": "ใช้รหัสที่ประสบความสำเร็จ",
  "ss_back_donation_detail": "การชำระเงิน",
  "ss_back_to_homepage_creator": "กลับไปที่หน้าแรกของผู้สร้าง",
  "ss_back_tod_detail": "ชำระเงิน",
  "ss_brand_gift_cashback": "Cashback",
  "ss_brand_gift_deal_name": "th_Tên deal",
  "ss_brand_gift_deal_price": "th_Giá deal",
  "ss_brand_gift_does_have_gift": "โอเค",
  "ss_brand_gift_does_not_have_gift": "ไม่",
  "ss_brand_gift_has_gift": "ของขวัญ",
  "ss_brand_gift_heart": "จำนวนหัวใจที่สะสมอยู่",
  "ss_brand_gift_heart_cashback_heart": "th_Đã hoàn",
  "ss_brand_gift_heart_left_heart": "th_Còn lại",
  "ss_brand_gift_heart_link_text": "คลิกเพื่อดูจำนวนหัวใจที่สะสมอยู่",
  "ss_brand_gift_heart_total_heart": "จำนวนหัวใจทั้งหมดที่สะสมอยู่",
  "ss_brand_gift_order_amount": "ราคา",
  "ss_brand_gift_order_support_info": "th_Bạn cần giúp đỡ",
  "ss_brand_gift_payment_history": "Brand Gift",
  "ss_brand_gift_showing_after_heart_text": "ได้รับ",
  "ss_brand_gift_showing_before_heart_text": "จำนวน",
  "ss_brand_gift_support_method": "th_Kênh hỗ trợ",
  "ss_brand_gift_title_type_ecommerce": "Online",
  "ss_brand_gift_title_type_o2o": "Offline",
  "ss_brand_gift_voucher": "บัตรกำนัลที่ใช้แล้ว",
  "ss_brand_rating_KOL_domain": "th_Trang KOL",
  "ss_brand_rating_back": "th_Hủy bỏ",
  "ss_brand_rating_back_to_payment_history": "th_Lịch sử mua hàng",
  "ss_brand_rating_button_update_payment_info": "th_Cập nhật ngay",
  "ss_brand_rating_cancel_order": "th_Admin hủy deal đơn hàng",
  "ss_brand_rating_cancel_order_sub_step_1": "th_Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cancel_order_sub_step_2": "th_Bạn đã cập nhật thông tin đánh giá sai 2 lần. Admin từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cashback": "th_Hoàn",
  "ss_brand_rating_content_1": "th_1. Ảnh đơn hàng yêu cầu các thông tin:",
  "ss_brand_rating_content_2": "th_2. Mã đơn hàng là mã được sàn TMDT cung cấp cho người mua sau khi tiến hành đặt hàng thành công.",
  "ss_brand_rating_content_3": "th_3. Email là thông tin bạn đã cung cấp để đăng ký nhận deal thành công.",
  "ss_brand_rating_content_child_1": "th_Đánh giá 5 sao (bắt buộc)",
  "ss_brand_rating_content_child_2": "th_Nội dung đánh giá tốt về sản phẩm (bắt buộc)",
  "ss_brand_rating_content_child_3": "th_Có ảnh/video về sản phẩm (không bắt buộc)",
  "ss_brand_rating_cover_image_helper": "th_Hỗ trợ: JPG, JPEG, GIF, PNG, BMP, WebP, tối đa 4MB",
  "ss_brand_rating_details_order": "th_Chi tiết đơn hàng",
  "ss_brand_rating_discount": "th_Giảm",
  "ss_brand_rating_edit": "th_Chỉnh sửa",
  "ss_brand_rating_end_time": "th_Hạn Deal",
  "ss_brand_rating_error_404": "th_Bạn không được phép truy cập vào link này",
  "ss_brand_rating_fill_code": "th_Mã đơn hàng",
  "ss_brand_rating_fill_email": "Email",
  "ss_brand_rating_get_cashback_from_passio": "th_Nhận hoàn tiền từ Passio",
  "ss_brand_rating_get_cashback_from_passio_sub": "th_Thời gian hoàn tiền tối đa trong 7 ngày. Trong trường hợp chưa cung cấp thông tin thanh toán, bạn cần cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_order_code": "th_Mã đơn hàng",
  "ss_brand_rating_order_content_child_1": "th_Tên sản phẩm trùng với tên sản phẩm của deal",
  "ss_brand_rating_order_content_child_2": "th_Mã đơn hàng",
  "ss_brand_rating_order_content_child_3": "th_Khoảng thông báo xác nhận chờ thanh toán (COD) và chờ vận chuyển (đã thanh toán)",
  "ss_brand_rating_order_heart": "th_Tim tích lũy",
  "ss_brand_rating_placeholder_code": "th_Nhập mã đơn hàng",
  "ss_brand_rating_register_deal_time": "th_Thời gian đăng ký Deal",
  "ss_brand_rating_save": "th_Lưu",
  "ss_brand_rating_showing_after_heart_text": "th_Danh sách sản phẩm",
  "ss_brand_rating_status": "th_Trạng thái",
  "ss_brand_rating_status_failed": "th_Từ chối",
  "ss_brand_rating_status_new": "th_Đang chờ",
  "ss_brand_rating_status_success": "th_Thành công",
  "ss_brand_rating_step_0_description": "th_Đơn hàng đăng ký từ hệ thống",
  "ss_brand_rating_step_0_title": "th_Đăng ký nhận Deal",
  "ss_brand_rating_step_1_description": "th_Upload ảnh đơn hàng hợp lệ và cập nhật các thông tin yêu cầu.",
  "ss_brand_rating_step_1_description_fail": "th_Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_step_1_fail": "th_Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_1_pending": "th_Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_1_title": "th_Cập nhật đơn hàng",
  "ss_brand_rating_step_2_description": "th_Upload ảnh đánh giá của bạn về sản phẩm mà bạn đã nhận",
  "ss_brand_rating_step_2_fail": "th_Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_2_pending_1": "th_Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_2_pending_2": "th_Bạn đã cập nhật sai thông tin. Chỉ còn 1 lần để bạn cập nhật lại.",
  "ss_brand_rating_step_2_title": "th_Đánh giá đơn hàng 5*",
  "ss_brand_rating_step_3_description": "th_Thời gian hoàn tiền tối đa trong 7 ngày. Trường hợp bạn chưa cung cấp thông tin thanh toán, vui lòng cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_step_3_description_clamp_heath": "th_Số tiền được hoàn tương đương với",
  "ss_brand_rating_step_3_description_done": "th_Thời gian hoàn tiền tối đa trong 7 ngày.",
  "ss_brand_rating_step_3_description_heart": "th_{{heart}}❤.",
  "ss_brand_rating_step_3_title": "th_Nhận hoàn tiền từ Passio",
  "ss_brand_rating_text_cash_back": "th_Hoàn tiền",
  "ss_brand_rating_text_percent": "th_Hoàn",
  "ss_brand_rating_title": "th_Tải ảnh đơn hàng",
  "ss_brand_rating_title_detail_order": "th_Chi tiết đơn hàng",
  "ss_brand_rating_title_hepler": "th_Lưu ý:",
  "ss_brand_rating_title_upload_rating": "th_Tải ảnh đánh giá đơn hàng",
  "ss_brand_rating_toast_success": "th_Bạn đã gửi thông tin thành công",
  "ss_brand_rating_update_order": "th_Cập nhật đơn đặt hàng",
  "ss_brand_rating_update_order_sub": "th_Bạn cần cập nhật thông tin mua đơn hàng thành công.",
  "ss_brand_rating_update_payment": "th_Câp nhật thông tin thanh toán",
  "ss_brand_rating_update_payment_info": "th_Cập nhật thanh toán",
  "ss_brand_rating_update_rating_sub": "th_Bạn cần cập nhật thông tin đánh giá 5 sao về sản phẩm",
  "ss_brand_rating_upload_cover_image": "th_Ảnh đơn hàng",
  "ss_brand_rating_upload_file_format_invalid_content": "Invalid image format. Supported format: JPG, JPEG, GIF, PNG, BMP, WebP",
  "ss_brand_rating_upload_file_size_invalid_content": "โปรดเลือกไฟล์ที่มีขนาดสูงสุด 10MB",
  "ss_brand_rating_upload_order": "th_Tải ảnh đơn hàng",
  "ss_brand_rating_upload_order_again": "th_Tải lại ảnh đơn hàng",
  "ss_brand_rating_upload_rating": "th_Cập nhật thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_rating_again": "th_Cập nhật lại thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_success_modal_order": "th_Chúc mừng bạn đã tải ảnh đơn hàng thành công! Bạn có thể theo dõi thêm lịch sử và trạng thái mua hàng.",
  "ss_brand_rating_upload_success_modal_rating": "th_Để nhận được hoàn tiền của chúng tôi, bạn cần cập nhật thông tin thanh toán",
  "ss_brand_rating_validate_code": "th_Trường dữ liệu không được để trống",
  "ss_brand_rating_validate_upload": "th_Trường dữ liệu không được để trống",
  "ss_call_hotline": "เรียกสายด่วน",
  "ss_checkout_disclamer_content_popup_tiktok": "เพื่อให้มีขั้นตอนการชำระเงินที่มีประสิทธิภาพมากยิ่งขึ้น โปรดเลือก \"เปิดในเบราว์เซอร์\"",
  "ss_checkout_disclamer_popup_tiktok": "ข้อจำกัดด้านความรับผิดชอบ",
  "ss_checkout_email_after": "ส่วนของ '@' ไม่มีไอคอน ''",
  "ss_checkout_email_before": "ด้านหลังของ '@' ไม่มีไอคอน ''",
  "ss_checkout_email_duplicate": "ส่วนที่อยู่เบื้องหลัง '@' ต้องไม่มี '@'",
  "ss_checkout_email_must": "โปรดรวม '@' ทางไปรษณีย์",
  "ss_checkout_phone_require": "กรุณากรอกหมายเลขโทรศัพท์",
  "ss_checkout_select_voucher": "คุณมีรหัสส่วนลด?",
  "ss_checkout_voucher_empty_text": "ไม่มีรหัสส่วนลด",
  "ss_checkout_voucher_empty_text_suggest": "หากต้องการเพิ่มรหัสส่วนลดโปรดป้อนและกดปุ่ม \"แอปพลิเคชัน\" ที่ด้านบน",
  "ss_convert_heart_amount_error": "หัวใจสะสมไม่เพียงพอ",
  "ss_convert_heart_button": "การเปลี่ยนใจ",
  "ss_convert_heart_choose_phone_scratch_card": "เลือกค่าพาร์ของการ์ดรอยขีดข่วน",
  "ss_convert_heart_convert_btn_cancle": "ยกเลิก",
  "ss_convert_heart_convert_btn_confirm": "ยืนยัน",
  "ss_convert_heart_error_phone_format": "คุณป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
  "ss_convert_heart_error_phone_required": "กรุณากรอกหมายเลขโทรศัพท์",
  "ss_convert_heart_info_1_hearts_convert": "1 หัวใจ",
  "ss_convert_heart_instruct_phone_number": "โปรดป้อนหมายเลขโทรศัพท์ที่แน่นอนที่คุณต้องการรับเงิน",
  "ss_convert_heart_number_convert": "จำนวนหัวใจที่ถูกดัดแปลง",
  "ss_convert_heart_phone_number_input": "หมายเลขโทรศัพท์",
  "ss_convert_heart_placeholder_phone_number": "ป้อนหมายเลขโทรศัพท์",
  "ss_convert_heart_request_existed": "มีการร้องขอให้เปลี่ยนใจรอการอนุมัติ โปรดกลับมาใหม่",
  "ss_convert_heart_send_request_convert": "ส่งต้องการ",
  "ss_convert_heart_success": "ส่งคำขอเปลี่ยนหัวใจที่ประสบความสำเร็จ โปรดรอ 3-5 วัน",
  "ss_convert_heart_title_popup": "สร้างข้อกำหนดการแปลงหัวใจ",
  "ss_convert_heart_verify_account_btn_cancel": "ยกเลิก",
  "ss_convert_heart_verify_account_btn_confirm": "การตรวจสอบบัญชี",
  "ss_convert_heart_warning_account_des_1": "กรุณาเข้าถึง",
  "ss_convert_heart_warning_account_des_2": "ประวัติโดยย่อ",
  "ss_convert_heart_warning_account_des_3": "เพื่อตรวจสอบบัญชี",
  "ss_convert_heart_warning_convert_des": "แน่ใจหรือว่าต้องการแปลงหัวใจสำหรับหมายเลขโทรศัพท์ของคุณ?",
  "ss_convert_heart_warning_convert_title": "ยืนยัน ?",
  "ss_copied": "คัดลอก",
  "ss_copy_failed": "Copy failed",
  "ss_create_account_donation": "สร้างบัญชี",
  "ss_creator": "ผู้สร้าง",
  "ss_creator_tod": "ผู้สร้าง",
  "ss_decline_status_tod": "ปฏิเสธ",
  "ss_details": "Details",
  "ss_disable_referral_button_share": "Chương trình kết thúc",
  "ss_discount_ammount": "การลดราคา",
  "ss_donate_success": "เงินโชคดีที่ประสบความสำเร็จ",
  "ss_donation_btn_checkout": "ส่ง",
  "ss_donation_checkout_email_notification": "👉 สินค้าของคุณจะถูกส่งทางอีเมล กรุณากรอกให้ถูกต้อง",
  "ss_donation_checkout_email_title": "อีเมล",
  "ss_donation_checkout_phone_placeholder": "09xxxxxx",
  "ss_donation_checkout_phone_title": "หมายเลขโทรศัพท์",
  "ss_donation_checkout_private_message_title": "ทำให้ข้อความเป็นส่วนตัว",
  "ss_donation_checkout_user_message_title": "ข้อความ",
  "ss_donation_code": "รหัสสนับสนุน",
  "ss_donation_confirm_leave_order": "ยังไม่ได้บันทึกการตั้งค่า คุณต้องการออกจากที่นี่?",
  "ss_donation_message_from_user": "ข้อความจากคุณ",
  "ss_donation_name_kol": "บริจาค",
  "ss_donation_pending_title": "การแลกเปลี่ยนอยู่ระหว่างดำเนินการ",
  "ss_donation_time": "สนับสนุนเวลา",
  "ss_donation_user_message_placeholder": "คุณลองส่งข้อความหาครีเอเตอร์",
  "ss_duplicate_email": "อีเมลได้ลงทะเบียนบัญชี",
  "ss_duplicate_username": "มีชื่อผู้ใช้",
  "ss_edit_profile": "แก้ไขบันทึก",
  "ss_email": "อีเมล",
  "ss_enter_course": "เข้าร่วมเดี๋ยวนี้",
  "ss_error_not_enough_money": "เกิดข้อผิดพลาดในปัจจุบันไม่สามารถชำระเงินได้",
  "ss_expired_voucher": "ขอโทษ! รหัสส่วนลดนี้หมดอายุแล้ว",
  "ss_fail_name_kol": "ความล้มเหลว",
  "ss_fan_add_voucher_button": "นำมาใช้",
  "ss_fan_brand_gift_title": "th_ƯU ĐÃI THƯƠNG HIỆU",
  "ss_fan_brand_rating_title": "th_GIAN HÀNG BÍ MẬT",
  "ss_fan_checkout_total_price": "ทั้งหมด",
  "ss_fan_date_picker_text_custom_range": "th_Tùy chỉnh khoảng thời gian",
  "ss_fan_date_picker_text_last_n_day": "th_{{n}} ngày gần nhất",
  "ss_fan_date_picker_text_last_week": "th_Tuần trước",
  "ss_fan_date_picker_text_this_month": "th_Tháng này",
  "ss_fan_date_picker_text_this_week": "th_Tuần này",
  "ss_fan_date_picker_text_today": "th_Hôm nay",
  "ss_fan_date_picker_text_yesterday": "th_Hôm qua",
  "ss_fan_empty_heart": "th_Không có đơn hàng được hoàn tim",
  "ss_fan_exclusive_passio_badge": "พิเศษ",
  "ss_fan_input_voucher_placeholder": "รหัสแทรก",
  "ss_fan_my_title": "รหัสส่วนลดของฉัน",
  "ss_fan_no_photo_has_been_selected": "th_Chưa có ảnh nào được chọn",
  "ss_fan_profile_help_channel_fb": "Kênh hỗ trợ",
  "ss_fan_profile_help_email": "Email",
  "ss_fan_profile_help_popup_title": "Trợ giúp",
  "ss_fan_profile_info": "ข้อมูลส่วนบุคคล",
  "ss_fan_upload_button_label": "th_Tải ảnh lên",
  "ss_fan_voucher_label_date": "ที่หมดอายุแล้ว:",
  "ss_fe_fan_edit_profile_cancel_button": "th_Hủy",
  "ss_fe_fan_edit_profile_confirm_button": "th_Xong",
  "ss_fe_fan_edit_profile_label_confirm": "ยืนยัน",
  "ss_fe_fan_edit_profile_personal_tax_code_had": "th_Đã có",
  "ss_fe_fan_edit_profile_personal_tax_code_had_not": "th_Chưa có",
  "ss_fe_fan_edit_profile_title_calender": "th_Chọn ngày",
  "ss_fe_fan_edit_profile_validate_date_identification": "th_Ngày cấp không hợp lệ",
  "ss_fe_fan_edit_profile_validate_invalid": "ข้อมูลอยู่ในรุปแบบที่ไม่ถูกต้อง",
  "ss_fe_fan_edit_profile_validate_max_length": "โปรดป้อนตัวอักษรไม่เกิน {{num}} ตัว",
  "ss_fe_fan_edit_profile_validate_number_0_to_9": "กรุณากรอกเฉพาะตัวเลข (0-9)",
  "ss_fe_fan_edit_profile_validate_required": "ช่องข้อมูลไม่สามารถเว้นว่างได้",
  "ss_fe_fan_edit_profile_validate_required_file": "th_Trường dữ liệu không được để trống 1 trong 2",
  "ss_fe_fan_profile_address_user": "th_Địa chỉ",
  "ss_fe_fan_profile_address_user_placeholder": "th_Nhập địa chỉ của bạn",
  "ss_fe_fan_profile_country_alias": "ประเทศ",
  "ss_fe_fan_profile_country_chosen": "เลือกประเทศ",
  "ss_fe_fan_profile_country_helper": "เลือกประเทศที่ตรงกับบัญชีรับเงิน",
  "ss_fe_fan_profile_momo_account": "บัญชี Momo",
  "ss_fe_fan_profile_momo_account_helper": "ช่องนี้ต้องตรงกับชื่อบัญชีผู้รับและไม่สามารถเปลี่ยนแปลงได้",
  "ss_fe_fan_profile_momo_account_name": "ชื่อบัญชีรับเงิน",
  "ss_fe_fan_profile_momo_account_name_placeholder": "ใส่ชื่อเจ้าของบัญชี",
  "ss_fe_fan_profile_momo_phone_placeholder": "ป้อนบัญชี MoMo ของคุณ",
  "ss_fe_fan_profile_payment_account_name": "ชื่อบัญชีรับเงิน",
  "ss_fe_fan_profile_payment_account_number": "เลขบัญชีรับเงิน",
  "ss_fe_fan_profile_payment_account_number_placeholder": "ใส่เลขที่บัญชี",
  "ss_fe_fan_profile_payment_alias": "จ่าย",
  "ss_fe_fan_profile_payment_bank_account": "บัญชีธนาคาร",
  "ss_fe_fan_profile_payment_bank_alias": "ธนาคารผู้รับผลประโยชน์",
  "ss_fe_fan_profile_payment_bank_name_placeholder": "ป้อนชื่อธนาคารผู้รับผลประโยชน์ของคุณ",
  "ss_fe_fan_profile_payment_branch": "สาขา",
  "ss_fe_fan_profile_payment_branch_new_placeholder": "th_Nhập chi nhánh ngân hàng của bạn",
  "ss_fe_fan_profile_payment_branch_placeholder": "ใส่ชื่อธนาคารของคุณ",
  "ss_fe_fan_profile_payment_date_identification": "th_Ngày phát hành KTP",
  "ss_fe_fan_profile_payment_file_back": "th_Mặt sau",
  "ss_fe_fan_profile_payment_file_front": "th_Mặt trước",
  "ss_fe_fan_profile_payment_file_helper": "th_Đính kèm 2 ảnh KTP của bạn: Mặt trước, mặt sau. Yêu cầu tải lên hình ảnh rõ ràng, chi tiết.",
  "ss_fe_fan_profile_payment_identification": "th_Số KTP",
  "ss_fe_fan_profile_payment_identification_placeholder": "th_Nhập số KTP",
  "ss_fe_fan_profile_payment_image_identification": "th_Ảnh KTP(Passport)",
  "ss_fe_fan_profile_payment_personal_tax": "th_Mã số thuế",
  "ss_fe_fan_profile_payment_personal_tax_placeholder": "th_Nhập mã số thuế cá nhân",
  "ss_fe_fan_profile_tl_alias": "ไทย",
  "ss_fe_fan_profile_vn_alias": "เวียดนาม",
  "ss_fe_fan_voucher_title": "รหัสส่วนลด",
  "ss_for_you": "ส่งถึงคุณ🤗",
  "ss_hotline": "สายด่วน",
  "ss_label_tod_link_success": "ข้อมูลเดียวความจริงหรือความกล้าถูกส่งไปยังอีเมล",
  "ss_lable_back_success_donation": "การสนับสนุนรายละเอียด",
  "ss_lable_back_success_tod": "รายละเอียดการจ่ายเงิน",
  "ss_lable_link_success": "ข้อมูลสนับสนุนได้ถูกส่งไปยังอีเมล",
  "ss_logout": "ออกจากระบบ",
  "ss_modal_timeout_register_now": "Daftar sekarang",
  "ss_next_register": "สร้างบัญชี",
  "ss_no": "ไม่ใช่",
  "ss_order_code": "คำสั่งซื้อรหัส",
  "ss_order_date": "ลำดับเวลา",
  "ss_order_detail": "รายละเอียดสั่งซื้อ",
  "ss_order_fail": "คำสั่งซื้อล้มเหลว",
  "ss_order_history_accepted": "ซึ่งรอคอย",
  "ss_order_history_empty_text": "คุณไม่มีผลิตภัณฑ์ใด ๆ",
  "ss_order_history_empty_text_suggest": "โปรดซื้อผลิตภัณฑ์เพื่อสนับสนุน KOL",
  "ss_order_history_new": "ใหม่",
  "ss_order_history_refund": "กลับมา",
  "ss_order_history_replied": "ทำ",
  "ss_order_history_reply_text": "ตอบ",
  "ss_order_message_from_kol": "ข้อเสนอแนะจาก KOL",
  "ss_order_message_from_user": "ข้อความจากคุณ",
  "ss_order_momo_wallet": "Momo E-Wallet",
  "ss_order_note_lucky_sent_email": "เงินโชคดีถูกส่งไปยังอีเมล",
  "ss_order_note_sent_email": "คำสั่งซื้อถูกส่งไปยังอีเมล",
  "ss_order_pending": "การธุรกรรมกำลังดำเนินการ",
  "ss_order_pending_title": "การธุรกรรมกำลังดำเนินการ",
  "ss_order_success": "สั่งซื้อความสำเร็จ",
  "ss_order_tod_date": "เวลาชำระเงิน",
  "ss_order_tod_message_from_kol": "การตอบสนองจากผู้สร้าง",
  "ss_payment_GBPRIMEPAY_CREDIT_CARD": "Credit Cards",
  "ss_payment_GBPRIMEPAY_QRCASH": "PromptPay",
  "ss_payment_GBPRIMEPAY_RABBIT_LINEPAY_WALLET": "LinePay",
  "ss_payment_GBPRIMEPAY_SHOPEEPAY_WALLET": "ShopeePay Wallet",
  "ss_payment_GBPRIMEPAY_TRUEMONEY_WALLET": "TrueMoney Wallet",
  "ss_payment_GBPRIMEPAY_WECHAT_WALLET": "Wechat Wallet",
  "ss_payment_history": "ประวัติความเป็นมา",
  "ss_payment_history_brand_rating": "th_Brand Ratings",
  "ss_payment_history_digital_product": "ผลิตภัณฑ์ดิจิตอล",
  "ss_payment_history_donation": "การบริจาค",
  "ss_payment_history_gift": "ของขวัญ",
  "ss_payment_history_tod": "ความจริงหรือกล้า",
  "ss_payment_method": "วิธีการชำระเงิน",
  "ss_payment_vnpay_qr_description": "th_Nhớ dùng mã giảm giá VNPAY bạn nhé!",
  "ss_payment_xendit_dana": "Dana Wallet",
  "ss_payment_xendit_gcash": "GCash Wallet",
  "ss_payment_xendit_grabpay": "กระเป๋าเงิน Grabpay",
  "ss_payment_xendit_ovo": "กระเป๋าเงิน ovo",
  "ss_payment_xendit_paymaya": "PayMaya Wallet",
  "ss_payment_xendit_shopeepay": "Shopeepay Indo",
  "ss_payment_xendit_virtual_account": "บัญชีเสมือนจริง",
  "ss_payment_xendit_virtual_account_bottom": "Bank Transfer",
  "ss_placeholder_profile_email": "ป้อนอีเมล",
  "ss_placeholder_profile_fullname": "ป้อนชื่อเต็มของคุณ",
  "ss_placeholder_profile_fullphone": "ป้อนหมายเลขโทรศัพท์ของคุณ",
  "ss_placeholder_profile_username": "ป้อนชื่อผู้ใช้",
  "ss_price_max_discount": "ลดน้อยลง",
  "ss_product_name": "ชื่อผลิตภัณฑ์",
  "ss_profile": "ไฟล์",
  "ss_profile_account_not_acctive": "บัญชีไม่ได้รับการรับรองความถูกต้อง",
  "ss_profile_active_account": "รับรองความถูกต้องตอนนี้",
  "ss_profile_btn_edit": "แก้ไขข้อมูล",
  "ss_profile_btn_edit_cancel": "ยกเลิก",
  "ss_profile_btn_edit_save": "บันทึก",
  "ss_profile_change_email_success": "ข้อมูลที่ประสบความสำเร็จ",
  "ss_profile_email": "อีเมล",
  "ss_profile_error_email": "กรุณากรอกรูปแบบอีเมลที่ถูกต้อง",
  "ss_profile_error_email_required": "กรุณากรอกอีเมล",
  "ss_profile_error_username_existed": "มีชื่อผู้ใช้",
  "ss_profile_error_username_matches": "อักขระที่อนุญาตจาก A-Z และ 0-9 เท่านั้น",
  "ss_profile_error_username_required": "กรุณากรอกชื่อผู้ใช้",
  "ss_profile_fullname": "ชื่อเต็ม",
  "ss_profile_fullname_error_max_length": "โปรดป้อนอักขระสูงสุด {{max}} อักขระ",
  "ss_profile_fullphone": "หมายเลขโทรศัพท์",
  "ss_profile_fullphone_error": "คุณป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
  "ss_profile_helptext_email": "หากคุณเปลี่ยนอีเมลคุณจะต้องตรวจสอบบัญชีของคุณ",
  "ss_profile_helptext_email_actived": "อีเมลได้รับการยืนยันแล้ว",
  "ss_profile_username": "ชื่อผู้ใช้",
  "ss_profile_username_error_max_length": "อนุญาตให้มากถึง 255 อักขระเท่านั้น",
  "ss_question_dare_for_you": "ความท้าทายจากคุณ",
  "ss_question_truth_for_you": "คำถามจากคุณ",
  "ss_recurring_payment_button_submit": "th_Thanh toán định kỳ",
  "ss_recurring_payment_field_email": "th_Email",
  "ss_recurring_payment_field_full_name": "th_Họ và tên",
  "ss_recurring_payment_field_phone": "th_Số điện thoại",
  "ss_recurring_payment_helper_field_email": "th_Sản phẩm của bạn sẽ được gửi qua email, bạn nhập chính xác nhé.",
  "ss_recurring_payment_info_title": "th_Thông tin khách hàng",
  "ss_recurring_payment_month": "th_tháng",
  "ss_recurring_payment_placeholder_field_email": "th_Your@example.com",
  "ss_recurring_payment_placeholder_field_full_name": "th_Tran Van A",
  "ss_recurring_payment_placeholder_field_phone": "th_09xxxxxxxxxx",
  "ss_referral_button_share": "แนะนำเพื่อนทันที",
  "ss_referral_campaign": "แนะนำเพื่อนทันที",
  "ss_referral_copy_link_error": "คัดลอกลิงค์ไปยังการแบ่งปันความล้มเหลว",
  "ss_referral_copy_link_success": "คัดลอกลิงค์เพื่อแบ่งปันความสำเร็จ",
  "ss_referral_creator_name": "ผู้สร้าง",
  "ss_referral_intro_step_1": "คัดลอกลิงค์แนะนำผลิตภัณฑ์",
  "ss_referral_intro_step_1_title": "ขั้นตอนที่ 1:",
  "ss_referral_intro_step_2": "แบ่งปันกับเพื่อน ๆ ทุกที่",
  "ss_referral_intro_step_2_title": "ขั้นตอนที่ 2:",
  "ss_referral_intro_step_3": "รับโบนัสเมื่อเพื่อนซื้อสำเร็จ",
  "ss_referral_intro_step_3_title": "ขั้นตอนที่ 3:",
  "ss_referral_intro_title_page": "แนะนำเพื่อนและรับรางวัล",
  "ss_referral_reward_recived": "รางวัลที่ได้รับ",
  "ss_referral_text_intro_description": "รางวัลที่คุณได้รับคือ \"หัวใจ\" บน Passio คุณจะถูกแปลงเป็นการ์ดรอยขีดข่วนเพื่อโหลดบนโทรศัพท์ของคุณ เพิ่มความสนุกสนานและรางวัลด้วยกันกลัวที่จะเชิญคุณ!",
  "ss_referral_text_title": "ผลิตภัณฑ์ที่คุณเลือก",
  "ss_referral_title_page": "แนะนำเพื่อน",
  "ss_register_link_to_login_page": "Login",
  "ss_register_success": "การลงทะเบียนบัญชีที่ประสบความสำเร็จ",
  "ss_retry": "ลองอีกครั้ง",
  "ss_showing": "การแสดง",
  "ss_store_btn_checkout": "จ่าย",
  "ss_store_can_not_place_order": "ไม่สามารถสั่งซื้อได้ในขณะนี้ กรุณาลองใหม่อีกครั้งในภายหลัง",
  "ss_store_checkout_email_notification": "👉ผลิตภัณฑ์ของคุณจะถูกส่งทางอีเมลป้อนอย่างแน่นอน",
  "ss_store_checkout_email_notification_bg": "ผลิตภัณฑ์ของคุณจะถูกส่งทางอีเมลป้อนอย่างแน่นอน",
  "ss_store_checkout_email_title": "อีเมล",
  "ss_store_checkout_error_E1": "ไม่มีรหัสส่วนลด!",
  "ss_store_checkout_error_E2": "ขอโทษ! รหัสส่วนลดนี้หมดอายุแล้ว",
  "ss_store_checkout_error_E3": "ยังไม่ได้ใช้รหัส กรุณาลองใหม่อีกครั้งในภายหลัง!",
  "ss_store_checkout_error_E4": "Oppp. รหัสส่วนลดหมดอายุแล้ว",
  "ss_store_checkout_error_E5": "คุณซื้อหลักสูตรนี้ โปรดตรวจสอบประวัติการสั่งซื้อ",
  "ss_store_checkout_error_EC": "The product is not available",
  "ss_store_checkout_error_EC1": "Out of stock",
  "ss_store_checkout_error_ES": "ไม่สามารถสั่งซื้อได้โปรดอีกครั้งในภายหลัง",
  "ss_store_checkout_phone_placeholder": "09xxxxxx",
  "ss_store_checkout_phone_title": "หมายเลขโทรศัพท์",
  "ss_store_checkout_private_message_title": "ตั้งค่าข้อความในโหมดส่วนตัว",
  "ss_store_checkout_user_message_title": "ข้อความ",
  "ss_store_confirm_leave_order": "คุณต้องการออกจากที่นี่หรือไม่?",
  "ss_store_copy_successfully": "คัดลอกสำเร็จ",
  "ss_store_copy_to_other_brower": "โปรดคัดลอกเส้นทางนี้และวางลงใน Safari เพื่อดำเนินการต่อ",
  "ss_store_copy_url": "คัดลอกเส้นทาง",
  "ss_store_create_account": "สร้างบัญชี ?",
  "ss_store_customer_information": "ข้อมูลลูกค้า",
  "ss_store_donation": "ข้อมูลการโดเนท",
  "ss_store_donation_payment_title": "เลือกวิธีการจ่ายเงิน",
  "ss_store_email_require": "กรุณากรอกอีเมล",
  "ss_store_free": "ไม่คิดเงิน",
  "ss_store_invalid_email": "คุณป้อนรูปแบบอีเมลที่ถูกต้อง",
  "ss_store_invalid_phone": "หมายเลขโทรศัพท์ของคุณไม่ถูกต้อง",
  "ss_store_invalid_username": "อักขระที่อนุญาตเท่านั้นเป็นคำธรรมดาจาก a-z และ 0-9",
  "ss_store_leave": "ออกจาก",
  "ss_store_momo_wallet": "Momo E-Wallet",
  "ss_store_order_detail": "จ่าย",
  "ss_store_order_item": "ข้อมูลผลิตภัณฑ์",
  "ss_store_password_min_length": "ความยาวขั้นต่ำ 6 อักขระ",
  "ss_store_password_require": "กรุณากรอกรหัสผ่าน",
  "ss_store_payment_deeplink": "ลิงค์การชำระเงิน",
  "ss_store_phone_require": "หมายเลขโทรศัพท์ของคุณไม่ถูกต้อง",
  "ss_store_require_payment": "กรุณาเลือกวิธีการชำระเงินให้กับสินค้านี้",
  "ss_store_shopeepay_wallet": "Shopeepay e -wallet",
  "ss_store_shoutout_item": "ข้อมูลวิดีโอตะโกน",
  "ss_store_tod_user_message_max_length": "เนื้อหามีความยาวเกิน 500 ตัวอักษร",
  "ss_store_user_message_max_length": "ข้อมูลบางอย่างเกินตัวละครที่อนุญาตให้ป้อนตรวจสอบอีกครั้ง",
  "ss_store_user_message_passio_placeholder": "กรุณาส่งข้อความถึงเรา!",
  "ss_store_user_message_placeholder": "คุณลองทำอะไรกับผู้สร้าง🤑",
  "ss_store_user_message_tooltip": "ข้อความนี้ไม่สามารถเปิดเผยต่อทุกคน เพียงแค่คุณและผู้สร้างเท่านั้นที่มองเห็นได้",
  "ss_store_username_max_length": "อนุญาตให้มากถึง 255 อักขระเท่านั้น",
  "ss_store_username_require": "กรุณากรอกชื่อผู้ใช้",
  "ss_store_virtual_item": "ข้อมูลของขวัญ",
  "ss_store_vnpay_atm": "บัตรเอทีเอ็ม",
  "ss_store_vnpay_atm_description": "ฝ่ายสนับสนุนธนาคารทางอินเทอร์เน็ต",
  "ss_store_vnpay_credit_card": "บัตรเครดิต / เดบิตระหว่างประเทศ",
  "ss_store_vnpay_qr": "VNPAY-QR / Internet banking",
  "ss_success_name_kol": "ความสำเร็จ",
  "ss_suggest_register_modal_content_text": "คุณต้องเข้าสู่ระบบหรือลงทะเบียนเพื่อดำเนินการต่อโดยใช้บริการของเรา",
  "ss_support_channel": "Support channel",
  "ss_support_email_info": "info@passio.eco",
  "ss_support_facebook": "Facebook",
  "ss_support_info": "สนับสนุนข้อมูล",
  "ss_support_phone_info": "024.77700700",
  "ss_title_tod_dare": "ข้อมูล Dare",
  "ss_title_tod_truth": "ข้อมูล Truth",
  "ss_tod_checkout_email_notification": "👉ข้อมูลความท้าทายของคุณจะได้ส่งผ่านทางอีเมล กรุณากรอกให้ถูกต้องนะคะ",
  "ss_tod_checkout_user_message_title": "เนื้อหาความท้าทาย",
  "ss_tod_dare_btn_checkout": "ส่ง",
  "ss_tod_dare_code": "รหัส Dare",
  "ss_tod_dare_name_kol": "ส่งความท้าทายไปยัง",
  "ss_tod_email_require": "กรุณากรอกอีเมล์ของคุณนะคะ",
  "ss_tod_invalid_email": "กรุณากรอกรูปแบบอีเมลให้ถูกต้องนะคะ",
  "ss_tod_invalid_phone": "กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้องนะคะ",
  "ss_tod_message_require": "ช่องนี้ไม่สามารถเว้นว่างได้",
  "ss_tod_pending_title": "การแลกเปลี่ยนอยู่ระหว่างดำเนินการ",
  "ss_tod_phone_require": "กรุณากรอกหมายเลขโทรศัพท์ของคุณนะคะ",
  "ss_tod_truth_btn_checkout": "ส่ง",
  "ss_tod_truth_code": "รหัสจริง",
  "ss_tod_truth_name_kol": "ส่งคำถามไปที่",
  "ss_tod_user_message_placeholder": "คุณลองส่งข้อความถึงครีเอเตอร์นะคะ🤑",
  "ss_total_price": "ทั้งหมด",
  "ss_verify_account_success": "ยินดีด้วย. คุณได้ตรวจสอบบัญชีของคุณสำเร็จแล้ว",
  "ss_video_shoutout_to": "ส่งคำขอไปที่ {{creator_name}}",
  "ss_view_detail": "ดูรายละเอียด",
  "ss_voucher_has_not_been_used": "ยังไม่ได้ใช้รหัส กรุณาลองใหม่อีกครั้งในภายหลัง!",
  "ss_voucher_not_exist": "ไม่มีรหัสส่วนลด!",
  "ss_voucher_out_of_use": "oppp. รหัสส่วนลดหมดอายุแล้ว",
  "ss_watch_content": "ดูเนื้อหา",
  "ss_watch_order_history": "ซื้อผลิตภัณฑ์แล้ว",
  "ss_your_voucher_code": "รหัสส่วนลดของคุณ",
  "sure_cancle_password": "แน่ใจหรือว่าต้องการยกเลิกการเปลี่ยนแปลง?",
  "system_error": "ระบบผิดพลาด",
  "title_checkout": "Passio - ชำระเงิน",
  "username": "ชื่อผู้ใช้",
  "username_placeholder": "ป้อนชื่อผู้ใช้",
  "video_shoutout": "วิดีโอตะโกน"
} 
} 
export default th